module.exports = __webpack_public_path__ + "img/my-reimbursements-background.2ace44e5.svg";